import React from 'react'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid'
import { isEqual, isSameMonth, isToday, parseISO, parse, add, format, startOfToday} from 'date-fns'

function classNames(...classes) {return classes.filter(Boolean).join(' ')}

const DayViewMiniSideCalendar = ({selectedDay, calendarDaysWithEvents, setSelectedDay, currentMonth, setCurrentMonth}) => {
    const [firstDayOfCurrentMonth, setFirstDayOfCurrentMonth] = React.useState(parseISO(currentMonth, 'MMMM yyyy', new Date()))

    React.useEffect(() => {
      setCurrentMonth(currentMonth)
      setFirstDayOfCurrentMonth(parse(currentMonth, 'MMMM yyyy', new Date()))
    }, [currentMonth])

    React.useEffect(() => {
      console.log(firstDayOfCurrentMonth)
    }, [firstDayOfCurrentMonth])

    const nextMonth = () => {
        let firstDayOfNextMonth = add(firstDayOfCurrentMonth, { months: 1})
        setCurrentMonth(format(firstDayOfNextMonth, 'MMMM yyyy'))
      }
    
    const prevMonth = () => {
      let firstDayOfNextMonth = add(firstDayOfCurrentMonth, { months: -1})
      setCurrentMonth(format(firstDayOfNextMonth, 'MMMM yyyy'))
    }

    const formatDateWithoutTimeZone = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      const milliseconds = String(date.getMilliseconds()).padStart(3, '0');
      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
    };
    


    const fixTheDate = (day) => {
      let checkedDay = typeof day === 'string' ? day : formatDateWithoutTimeZone(day)
      const [year, month, date] = checkedDay.split('-').map(Number);
      return new Date(year, month - 1, date);
  }

    return (
        <div className="hidden w-1/2 max-w-md flex-none border-l border-gray-100 py-10 px-8 md:block">
          <div className="flex items-center text-center text-gray-900">
            <button type="button" onClick={prevMonth} className="-m-1.5 flex flex-none items-center justify-center p-1.5 border-none cursor-pointer bg-white text-gray-400 hover:text-gray-500">
              <span className="sr-only">Previous month</span>
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
            </button>
            <div className="flex-auto font-semibold">{currentMonth}</div>
            <button type="button" onClick={nextMonth} className="-m-1.5 flex flex-none items-center justify-center p-1.5 border-none cursor-pointer bg-white text-gray-400 hover:text-gray-500">
              <span className="sr-only">Next month</span>
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
            </button>
          </div>
          <div className="mt-6 grid grid-cols-7 text-center text-xs leading-6 text-gray-500">
            <div>S</div>
            <div>M</div>
            <div>T</div>
            <div>W</div>
            <div>T</div>
            <div>F</div>
            <div>S</div>
          </div>
          <div className="isolate mt-2 grid grid-cols-7 rounded-lg gap-px bg-gray-200 text-sm shadow ring-1 ring-gray-200">
            {Object.keys(calendarDaysWithEvents).map((day, dayIdx) => (
              <button
                key={day}
                type="button"
                onClick={() => setSelectedDay({date: day, events: calendarDaysWithEvents[day].events, availabilities: calendarDaysWithEvents[day].availabilities})}
                className={classNames(
                  'py-1.5 hover:bg-gray-100 border-gray-300 cursor-pointer border-0 focus:z-10',
                  isSameMonth(parseISO(day), firstDayOfCurrentMonth) ? 'bg-white' : 'bg-blue-50',
                  (isEqual(parseISO(day), fixTheDate(selectedDay.date)) || isToday(parseISO(day))) && 'font-semibold',
                  isEqual(parseISO(day), fixTheDate(selectedDay.date)) && 'text-white',
                  !isEqual(parseISO(day), fixTheDate(selectedDay.date)) && isSameMonth(parseISO(day), firstDayOfCurrentMonth) && !isToday(parseISO(day)) && 'text-gray-900',
                  !isEqual(parseISO(day), fixTheDate(selectedDay.date)) && !isSameMonth(parseISO(day), firstDayOfCurrentMonth) && !isToday(parseISO(day)) && 'text-gray-400',
                  isToday(parseISO(day)) && !day.isSelected && 'text-indigo-600',
                  dayIdx === 0 && 'rounded-tl-lg',
                  dayIdx === 6 && 'rounded-tr-lg',
                  dayIdx === Object.keys(calendarDaysWithEvents).length - 7 && 'rounded-bl-lg',
                  dayIdx === Object.keys(calendarDaysWithEvents).length - 1 && 'rounded-br-lg'
                )}
              >
                <time
                  dateTime={day.date}
                  className={classNames(
                    'mx-auto flex h-7 w-7 items-center justify-center rounded-full',
                    isEqual(parseISO(day), fixTheDate(selectedDay.date)) && isToday(parseISO(day)) && 'bg-indigo-600 text-white',
                    isEqual(parseISO(day), fixTheDate(selectedDay.date)) && !isToday(parseISO(day)) && 'bg-gray-500 text-white font-bold'
                  )}
                >
                  {day.split('-').pop().replace(/^0/, '')}
                </time>
              </button>
            ))}
          </div>
        </div>
    )
}
export default DayViewMiniSideCalendar